// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LLXo","top":"styles_top__3nxVz","left":"styles_left__2qLmw","description":"styles_description__1Kuih"};